import { createStyles, makeStyles, Typography } from '@material-ui/core'
import React, { useRef, useState } from 'react'
import { useMessages } from '../../../../hooks/snackbarHooks'

interface StandaloneImageDropzoneProps {
  onAdd: (file: File) => void;

  className?: string
}

export const StandaloneImageDropzone = ({onAdd, className}: StandaloneImageDropzoneProps) => {
  const classes = useStyles()

  const inputRef = useRef<HTMLInputElement>(null)

  const [dragActive, setDragActive] = useState(false)

  const {showError} = useMessages()

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    setDragActive(false)
    handleFiles(e.dataTransfer.files)
  }

  const handleFiles = (files: FileList) => {
    const arr = Array.from(files)
    const notImages = arr.filter(file => !file.type.startsWith('image/'))
    if (notImages.length > 0) {
      showError('Можно загружать только изображения!')
      return
    }

    const selected = files[0]
    if (selected) {
      onAdd(selected)
    }
  }

  return <div
    className={`${classes.dropzone} ${dragActive ? 'active' : ''} ${className}`}
    onClick={() => inputRef.current?.click()}
    onDragOver={e => {
      e.preventDefault()
      setDragActive(true)
    }}
    onDragLeave={() => setDragActive(false)}
    onDrop={handleDrop}
  >
    <Typography variant="body1" color="textSecondary" className={classes.text}>
      Перетащите изображение сюда или кликните для выбора
    </Typography>
    <input
      type="file"
      accept="image/*"
      hidden
      ref={inputRef}
      onChange={e => {
        if (e.target.files) {
          handleFiles(e.target.files)
        }
        e.target.value = ''
      }}
    />
  </div>
}

const useStyles = makeStyles(() =>
  createStyles({
    dropzone: {
      border: '2px dashed #ced4da',
      borderRadius: 8,
      padding: 16,
      textAlign: 'center',
      backgroundColor: '#fff',
      cursor: 'pointer',
      transition: 'background 0.2s',
      '&.active': {
        backgroundColor: '#f0f4ff'
      },
      '&.small': {
        height: 'auto',
        textAlign: 'center',
      },
      height: '200px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center'
    },
    text: {
      fontSize: 12
    }
  })
)